<template>
  <b-carousel
    id="carousel-interval"
    controls
    indicators
    :interval="5000"
    class="position-relative"
  >
    <b-carousel-slide class="rounded overflow-hidden" :img-src="value.photo" v-for="(value, index) in slides" :key="index" :data="value"/>
  </b-carousel>
</template>

<script>
import { BCarousel, BCarouselSlide } from 'bootstrap-vue'

export default {
  components: {
    BCarousel,
    BCarouselSlide,
  },
  data() {
    return {
      url: '',
      slides: [],
    }
  },
  methods: {
    readSlides() {
      const that = this
      that.$http.get(`${this.url}/api/slides`,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          that.slides = response.data
        }).catch()
    },
  },
  created() {
    this.url = 'https://tojtel.tj'
    this.readSlides()
  },
}
</script>
<style scoped>
.rounded{
  border-radius: 1.3rem !important;
}
</style>
